import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { PaymentCompleteComponent } from './payment-complete.component';

export const ngxPaymentCompleteModule = angular.module('ngxPaymentCompleteModule', [])
	.directive('ngxPaymentComplete', downgradeComponent({ component: PaymentCompleteComponent }))
	.name;
